import { Instance } from 'mobx-state-tree';
import { RouteReOptimizingDtoModelBase } from './RouteReOptimizingDtoModel.base';

/* The TypeScript type of an instance of RouteReOptimizingDtoModel */
export interface RouteReOptimizingDtoModelType extends Instance<typeof RouteReOptimizingDtoModel.Type> {}

/* A graphql query fragment builders for RouteReOptimizingDtoModel */
export { selectFromRouteReOptimizingDto, routeReOptimizingDtoModelPrimitives, RouteReOptimizingDtoModelSelector } from './RouteReOptimizingDtoModel.base';

/**
 * RouteReOptimizingDtoModel
 */
export const RouteReOptimizingDtoModel = RouteReOptimizingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
